import React from "react";
import RuleForm from "../RuleForm";
import {useRuleForm} from "../hooks";
import {useTranslation} from "react-i18next";
import {useCheckEditData} from "../../checks/hooks";
import AuthorizedError404 from "../../error/AuthorizedError404";
import {withErrorBoundary} from "../../../components/ErrorBoundary";
import {CCard, CCardBody, CCardFooter, CCardHeader} from "@coreui/react";
import FormControlsButtons from "../../../components/FormControlButtons";

const RuleAdd = () => {
  const {t} = useTranslation();
  const {isProjectAdmin} = useCheckEditData();
  const {onFormSubmit, onFormReset, Prompt, formControl, formId, checkId} = useRuleForm();

  if (checkId && !isProjectAdmin) {
    return <AuthorizedError404/>;
  }

  return (
    <CCard className="RuleAdd-card">
      <CCardHeader>
        <h1 className="card-header-text">
          {t("card.title.rule.add", "Add rule")}
        </h1>
      </CCardHeader>
      <CCardBody>
        <Prompt/>
        <RuleForm
          formId={formId}
          formControl={formControl}
          onFormSubmit={onFormSubmit}
        />
      </CCardBody>
      <CCardFooter>
        <FormControlsButtons
          form={formId}
          onCancelClick={onFormReset}
        />
      </CCardFooter>
    </CCard>
  );
};

export default withErrorBoundary(RuleAdd);